import { AxiosResponse } from 'axios';
import { uniqBy } from 'lodash';

import { axiosInstance } from '@tgg/micro-services/axios';
import { clientLogger, GymDto, SummarisedBranch } from '@tgg/services';
import { isAxiosError, relativeUrlWithBasePath } from '@tgg/util';

import { applicationIdentifier } from '../../../core/constants';
import {
    getGymsVisitHistoryCookie,
    updateGymsVisitHistoryCookie,
} from '../../../core/cookies';

export const getMappedVisitedGyms = async (gym: SummarisedBranch) => {
    const gymsVisitHistoryCookie = getGymsVisitHistoryCookie();
    const visitedGyms = (gymsVisitHistoryCookie?.visitedGyms ?? []).slice(-2);
    const gymProxyRouteUrl = relativeUrlWithBasePath(
        `/api/proxy/gyms/${gym.BranchId}`,
    );

    clientLogger.info(
        `clientside FindYourGym - about to call ${gymProxyRouteUrl} to get gyms`,
        applicationIdentifier,
    );

    try {
        const { data }: AxiosResponse<GymDto> = await axiosInstance.get<
            any,
            AxiosResponse<GymDto>
        >(gymProxyRouteUrl);
        const formattedPath = data.website?.replace(
            'https://www.thegymgroup.com',
            '',
        );
        updateGymsVisitHistoryCookie({
            visitedGyms: uniqBy(
                [
                    ...visitedGyms,
                    {
                        branchName: gym.Name,
                        branchPath: formattedPath as string,
                    },
                ],
                'branchName',
            ),
        });
    } catch (error) {
        if (isAxiosError(error)) {
            clientLogger.error(
                `clientside GET /api/proxy/gyms/${
                    gym.BranchId
                } failed in FindYourGym - got error: ${JSON.stringify(
                    error.response?.data,
                )}`,
                applicationIdentifier,
            );
        } else {
            clientLogger.error(
                `clientside GET /api/proxy/gyms/${
                    gym.BranchId
                } failed in FindYourGym: ${(error as Error).message}`,
                applicationIdentifier,
            );
        }
    }
};
